module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('link', {
    attrs: {
      "href": "styles/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('title', [_vm._v("The Angel\nAnswer Book")]), _vm._v(" "), _c('p', {
    staticClass: "ser1",
    attrs: {
      "id": "aa_3"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images/img-5-1.jpg",
      "src": "images/img-5-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "pANEL"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/contents#bb_3"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#007467"
    }
  }, [_vm._v("What are angels?")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "pACk3"
    }
  }, [_c('span', {
    staticClass: "dcap",
    staticStyle: {
      "color": "#007467"
    }
  }, [_vm._v("A")]), _vm._v("ngels are intelligent beings created by God as part of His spiritual realm. The\nword\n"), _c('i', [_vm._v("angel")]), _vm._v("\nmeans "), _c('i', [_vm._v("messenger")]), _vm._v(", and they were created to serve and glorify their Creator. The Bible\nrefers to them as “ministering spirits,” “heavenly hosts,” and “holy ones” (Hebrews\n1:14; Psalm 103:21; Jude 1:14). ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba7292e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter03.vue
// module id = 75
// module chunks = 0